export function Logo({ size = 28, withText = true }: { size?: number; withText?: boolean }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        fontWeight: 800,
        fontSize: size * 0.72,
        color: 'var(--text)',
      }}
    >
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
        <rect width="32" height="32" rx="8" fill="#4f46e5" />
        <rect x="7" y="7" width="11" height="11" rx="2" fill="#fde047" />
        <rect x="14" y="14" width="11" height="11" rx="2" fill="#fff" opacity=".92" />
      </svg>
      {withText && <span style={{ letterSpacing: '-0.02em' }}>miroom</span>}
    </span>
  );
}
